import React from 'react';
import imgNotFound from '../Image/not-found.svg';
import { useNavigate } from 'react-router-dom';

export default function PageNotFound() {
  const navigate = useNavigate();
// alert("hii");
  const handleBacktoHome = () => {
    navigate('/'); 
  };

  return (
    <>
 
      <div className="container">
        <section className="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
          <h1>404</h1>
          <h2>The page you are looking for doesn't exist.</h2>
          <button className="btn" onClick={handleBacktoHome}>Back to home</button>
          <img src={imgNotFound} className="img-fluid py-5" alt="Page Not Found" />
          <div className="credits"></div>
        </section>
      </div>
    </>
  );
}
